import { RequestTarget } from './Request';
import { get as getToken } from './authTokens';

const prefix = 'Bearer ';

export async function getAuthHeader(target: RequestTarget) {
    const token = await getToken(target);
    return prefix + token.jwt;
}
